module.exports = __webpack_public_path__ + "img/bg-hex-light.bdf144b.png";